import { filter, map, reject } from 'lodash';

const isVegetarianOrSingle = tag => {
  return /vegetarian|single/i.test(tag);
};

const firstCharacter = tag => {
  return tag[0];
};

const dietTags = tags => {
  return map(filter(tags, isVegetarianOrSingle), firstCharacter).join(', ');
};

const regularTags = tags => {
  return map(reject(tags, isVegetarianOrSingle), firstCharacter).join(', ');
};

export const MealPlanTags = {
  transclude: true,

  bindings: {
    tags: '<',
    type: '@',
  },

  template: `
    <span class="meal-plan-tags" ng-show="$ctrl.tagNames !== ''">
      <span class="px-1" ng-transclude></span>
      {{ $ctrl.tagNames }}
    </span>`,

  controller() {
    return {
      $onInit() {
        this.tagNames =
          this.type === 'diet' ? dietTags(this.tags) : regularTags(this.tags);
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanTags.js